<template>
  <div class="metrics" v-if="metric">
    <h1 class="metric-company-name">{{ metric ? metric.name : '' }}</h1>
    <div class="metric-chart metric-left-chart">
      <VueApexCharts type="radialBar" :height="chartHeight" :options="getSickDaysChartConfig"
                     :series="[getAverageSickDaysPercentage]"></VueApexCharts>
    </div>
    <div class="metric-chart metric-right-chart">
      <VueApexCharts type="radialBar" :height="chartHeight" :options="getPlacementInHoursChartConfig"
                     :series="[getAveragePlacementInHoursPercentage]"></VueApexCharts>
    </div>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'customer-metric',
  props: ['metric'],
  components: {VueApexCharts},
  data() {
    return {
      chartHeight: 600
    }
  },
  computed: {
    getAverageSickDaysPercentage() {
      return Math.round(this.metric.averageSicknessPerPlacing * 100)
    },
    getAveragePlacementInHoursPercentage() {
      return Math.round(this.metric.averagePlacementInHoursPercentage * 1000) / 10
    },
    getSickDaysChartConfig() {
      // Calculate color
      const level0 = '#25b7bc';
      const level1 = '#f8e200';
      const level2 = '#ff8400';
      const level3 = '#ff0000';
      let color = level0;
      let value = this.getAverageSickDaysPercentage;
      if (value >= 3) {
        color = level3;
      } else  if (value >= 2.8) {
        color = level2;
      } else  if (value >= 2.5) {
        color = level1;
      }
      
      return {
        chart: {
          height: this.chartHeight,
          type: 'radialBar'
        },
        fill: {
          colors: [color]
        },
        plotOptions: {
          radialBar: {
            startAngle: -135,
            endAngle: 135,
            hollow: {
              size: '70%',
            },
            dataLabels: {
              name: {
                fontSize: '50px',
                color: '#25b7bc',
                offsetY: 0
              },
              value: {
                show: true,
                offsetY: 50,
                fontSize: '50px',
                formatter: function (val) {
                  return `${Math.round(val * 100) / 100}%`
                }
              }
            }
          },
        },
        labels: ['Ziekteverzuim'],
      };
    },
    getPlacementInHoursChartConfig() {
      const color0 = '#25b7bc';
      const color1 = '#666666'
      let color = color0;
      if (this.getAveragePlacementInHoursPercentage < 100) {
        color = color1;
      }
      return {
        chart: {
          height: this.chartHeight,
          type: 'radialBar',
        },
        fill: {
          colors: [color]
        },
        plotOptions: {
          radialBar: {
            startAngle: -135,
            endAngle: 135,
            hollow: {
              size: '70%',
            },
            dataLabels: {
              name: {
                fontSize: '50px',
                color: '#25b7bc',
                offsetY: 0
              },
              value: {
                show: true,
                offsetY: 50,
                fontSize: '50px',
                formatter: function (val) {
                  return `${Math.round(val * 100) / 100}%`
                }
              }
            }
          },
        },
        labels: ['Effectiviteit'],
      };
    }

  }
}
</script>

<style lang="scss">
.metrics {
  height: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: auto 1fr;
  grid-column-gap: 12px;
  grid-row-gap: 12px;
  padding: 3rem;
}

.metric-company-name {
  grid-area: 1 / 1 / 2 / 3;
  font-size: 70px;
}

.metric-left-chart {
  grid-area: 2 / 1 / 3 / 2;
  align-self: center;
}

.metric-right-chart {
  grid-area: 2 / 2 / 3 / 3;
  align-self: center;
}


</style>